import { FC } from 'react';
import Image from 'next/image';

import { icon_3d_cube } from '@gn-audio/icons';
import { JabraIcon } from '@gn-audio/jss-components';

import { FamilyGroup } from 'api/productCatalogueApi';
import { JabraSlide, JabraSlider } from 'common/components/JabraSlider/JabraSlider';
import { Product3DView } from 'common/components/Product3dView';
import { classNames } from 'common/utils/classNames';
import { getGroupAttributesObject } from 'composables/Product/Buy/customizerHelpers';

export interface FullScreenImageSliderProps {
  group: FamilyGroup;
}

export const FullScreenImageSlider: FC<FullScreenImageSliderProps> = ({ group }) => {
  const prodSpecs = getGroupAttributesObject(group);

  const [uuid] = prodSpecs.Meta_3dRenderingUuid ?? [];
  const slides = group.images.map((image) => {
    return (
      <JabraSlide
        key={image.url}
        renderThumbnail={(selected) => {
          return (
            <div
              className={classNames(
                'flex h-16 w-16 items-center justify-center rounded-md border border-gray-700 p-1 outline-2 outline-focus group-focus-visible/slider-thumbnail:outline',
                selected ? 'border border-yellow' : undefined
              )}
            >
              <Image
                className="h-[3rem] w-[3rem]"
                src={`https:${image.url}`}
                alt={group.name}
                width={200}
                height={200}
              />
            </div>
          );
        }}
      >
        <Image
          className="mb-8 h-[calc(100vh-13rem)] object-contain"
          key={image.url}
          src={`https:${image.url}`}
          alt={group.name}
          width={1000}
          height={1000}
        />
      </JabraSlide>
    );
  });

  if (uuid) {
    slides.push(
      <JabraSlide
        key="3d"
        renderThumbnail={(selected) => {
          return (
            <div
              className={classNames(
                'flex h-16 w-16 items-center justify-center rounded-md border border-gray-700 p-1 outline-2 outline-focus group-focus-visible/slider-thumbnail:outline',
                selected ? 'border border-yellow' : undefined
              )}
            >
              <JabraIcon className="h-[2.5rem] text-black dark:text-white" Icon={icon_3d_cube} />
            </div>
          );
        }}
      >
        <Product3DView productUuid={uuid} productName={group.productName} />
      </JabraSlide>
    );
  }

  return (
    <JabraSlider showSlideArrows={false} slideClassName="basis-full">
      {slides}
    </JabraSlider>
  );
};
